import { createFileRoute, redirect, Outlet } from '@tanstack/react-router';
import styles from './account.module.scss';

export const Route = createFileRoute('/account')({
  component: AccountPage,
  beforeLoad: async ({ context }) => {
    // CRITICAL: Require authentication for account page
    const { user, authLoading } = context as { user: any; authLoading: boolean };

    // Don't redirect while auth is still loading
    if (authLoading) {
      return;
    }

    if (!user) {
      console.warn('Unauthorized access attempt to account page');
      throw redirect({
        to: '/',
      });
    }
  },
});

function AccountPage() {
  return (
    <div className={styles.account}>
      <Outlet />
    </div>
  );
}
